import { render } from "./Advertisements.vue?vue&type=template&id=45e05cfa"
import script from "./Advertisements.vue?vue&type=script&lang=js"
export * from "./Advertisements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__